import {Toggle} from 'material-ui';
import FlatButton from 'material-ui/FlatButton';
import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import styled from 'styled-components';

import {DetailMissingInputError} from '../errors/InputErrors';
import {ROLE_SELECT, ROLE_USER, ROLE_ADMIN} from '../constants/userConstants';
import {
  filterOutNotDefinedValues,
  ActionButtonRow,
  ErrorMessage,
  HeadlineH1,
  HeadlineH2,
  convertErrors,
  Select,
} from 'arkulpa-fec';

export const TwoColContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HalfWidth = styled.div`
  width: 50%;
`;

export default class extends Component {
  constructor(props) {
    super(props);
    let user = {};
    if (props.data && props.data.user) {
      user = props.data.user;
    }
    this.state = {
      email: '',
      phone: '',
      active: true,
      firstName: '',
      lastName: '',
      password: '',
      role: ROLE_USER,
      changePassword: false,
      ...filterOutNotDefinedValues(user),
    };
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    } else {
      const {user} = newProps.data || {};
      this.setState({errors: [], ...filterOutNotDefinedValues(user)});
    }
  };
  _goBackToList = () => {
    let {length, goBack, replace} = this.props.history;
    if (length > 2) {
      goBack();
    } else {
      replace('/users');
    }
  };

  _renderHeadline = () => {
    if (this.props.register) {
      return <HeadlineH1>Benutzer registrieren</HeadlineH1>;
    } else if (this._isNew()) {
      return <HeadlineH1>Neuer Benutzer</HeadlineH1>;
    } else if (this._isAdmin()) {
      return <HeadlineH1>Benutzer bearbeiten</HeadlineH1>;
    }
    return <HeadlineH1>Meine Daten bearbeiten</HeadlineH1>;
  };

  _isNew = () => !this.state._id;

  _isAdmin = () => this.props.user && this.props.user.role === ROLE_ADMIN;

  _save = () => {
    let {...state} = filterOutNotDefinedValues(this.state);
    if (this._isNew() && !state.password) {
      this.setState({errors: [DetailMissingInputError('Passwort')]});
      return;
    }
    this.setState({savingStatus: 'Benutzer wird gespeichert...'});
    this.props
      .save({
        ...state,
      })
      .then(() => {
        this.setState({savingStatus: undefined});
        this._goBackToList();
      })
      .catch((rawErrors) => {
        this.setState({savingStatus: undefined});
        let errors = convertErrors(rawErrors);
        this.setState({errors});
        console.log('there was an error sending the query', errors);
      });
  };

  _renderButtons = () => {
    let {savingStatus} = this.state;
    let isSaving = !!savingStatus;
    if (!this.props.register) {
      return (
        <ActionButtonRow>
          {this._isAdmin() ? <FlatButton onClick={this._goBackToList} label='Zurück zur Übersicht' /> : <div />}
          <div>
            {!this._isNew() && <FlatButton onClick={() => this.setState({deleteModalOpen: true})} label='löschen' />}
            {!this._isNew() && (
              <FlatButton onClick={() => this.setState({changePassword: true})} label='Passwort ändern' />
            )}
            <FlatButton
              primary
              onClick={this._save}
              label={isSaving ? savingStatus : 'speichern'}
              disabled={isSaving}
            />
          </div>
        </ActionButtonRow>
      );
    }
    return (
      <ActionButtonRow>
        <FlatButton onClick={() => this.props.history.replace('/login')} label='Zurück zum Login' />
        <div>
          <FlatButton
            primary
            onClick={this._save}
            label={isSaving ? savingStatus : 'Benutzer anlegen'}
            disabled={isSaving}
          />
        </div>
      </ActionButtonRow>
    );
  };

  render() {
    let {email, phone, active, firstName, lastName, password, role, changePassword} = this.state;
    const {register} = this.props;
    let isAdmin = this._isAdmin();
    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        {this._renderHeadline()}
        <TwoColContent>
          {(isAdmin || register) && (
            <HalfWidth>
              <TextField
                type='text'
                fullWidth={true}
                floatingLabelText='Email*'
                value={email}
                onChange={({target: {value}}) => this.setState({email: value})}
              />
            </HalfWidth>
          )}
          {isAdmin && (
            <HalfWidth>
              <Toggle
                label={'Benutzer ' + (active ? 'aktiviert' : 'deaktiviert')}
                labelPosition='right'
                toggled={active}
                onToggle={(_, active) => this.setState({active})}
              />
            </HalfWidth>
          )}
        </TwoColContent>
        {isAdmin && (
          <TwoColContent>
            <HalfWidth>
              <Select
                label='Berechtigung'
                items={ROLE_SELECT}
                selectedItem={role}
                changeMethod={(role) => this.setState({role})}
              />
            </HalfWidth>
          </TwoColContent>
        )}
        <TwoColContent>
          <HalfWidth>
            <TextField
              type='text'
              fullWidth={true}
              floatingLabelText='Vorname*'
              value={firstName}
              onChange={({target: {value}}) =>
                this.setState({
                  firstName: value,
                })
              }
            />
          </HalfWidth>
          <HalfWidth>
            <TextField
              type='text'
              fullWidth={true}
              floatingLabelText='Nachname*'
              value={lastName}
              onChange={({target: {value}}) =>
                this.setState({
                  lastName: value,
                })
              }
            />
          </HalfWidth>
        </TwoColContent>
        <HeadlineH2>Kontaktdaten</HeadlineH2>
        <TextField
          type='text'
          fullWidth={true}
          floatingLabelText='Telefonnummer*'
          value={phone}
          onChange={({target: {value}}) =>
            this.setState({
              phone: value,
            })
          }
        />
        {(this._isNew() || changePassword || register) && (
          <div>
            <HeadlineH2 style={{marginBottom: 0}}>Passwort</HeadlineH2>
            <TextField
              type='password'
              fullWidth={true}
              floatingLabelText='Passwort*'
              value={password}
              onChange={({target: {value}}) =>
                this.setState({
                  password: value,
                })
              }
            />
          </div>
        )}
        {this._renderButtons()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserForm.js